import {Message} from "semantic-ui-react";

export default function InviteInfo(props: {info: string}){

    return(
        <Message info>
         {props.info}
        </Message>
    )
}